import axios from 'axios';
import { NEXT_PUBLIC_PROD_URL } from '../env';
// import { ToastNotification } from '../Utils/ToastNotifications';
import Cookies from 'js-cookie';
import { useSnackbar } from 'notistack';

export const baseURL = NEXT_PUBLIC_PROD_URL;



export const instance = axios.create({
  baseURL: baseURL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const makeRequest = async (type, path, body = null, options = {}) => {
  console.log("path is ====", path)
  try {
    // Retrieve token from cookies
    const token = Cookies.get('auth-token');

    // Setup headers
    const headers = {
      ...options.headers,
      'auth-token': token ? token : null,
    };

    // If the body is an instance of FormData, set the appropriate Content-Type
    if (body instanceof FormData) {
      headers['Content-Type'] = 'multipart/form-data';
    } else if (body) {
      headers['Content-Type'] = 'application/json';
    }

    // Create the config object
    const config = {
      timeout: 30000,
      headers,
      ...options,
    };

    let response;

    // Perform the request based on the type
    switch (type.toUpperCase()) {
      case 'GET':
        response = await instance.get(path, config);
        break;
      case 'POST':
        response = await instance.post(path, body, config);
        break;
      case 'PUT':
        response = await instance.put(path, body, config);
        break;
      case 'PATCH':
        response = await instance.patch(path, body, config);
        break;
      case 'DELETE':
        response = await instance.delete(path, config);
        break;
      default:
        throw new Error('Unsupported request type');
    }

    return response;
  } catch (error) {
    console.error('Error making request:', error);
    console.error('Error object:', JSON.stringify(error, null, 2));
    // Handle specific errors
    if (error.response?.status) {
      console.log("erororoorororoor")
      // Handle unauthorized error, such as refreshing tokens or redirecting
      // ToastNotification('error', 'Session expired. Please login again');
    } else if (error.code === 'ECONNABORTED') {
      // Handle timeout
      // ToastNotification('error', 'Request timed out');
    }

    throw error; // Re-throw error after logging/handling
  }
};


// Optional: Request interceptor for adding authentication or other common headers
instance.interceptors.request.use(
  (config) => {
    // Example: Add basic auth or other configuration if needed
    // config.auth = { username, password };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Optional: Response interceptor for handling global responses or errors
instance.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    // Return the error message so it can be handled by the calling component
    const errorData = error.response?.data;
    let errorMessage = "Something went wrong";

    if (errorData) {
      // 1. Check for Amadeus-style errors in 'message' field (as an object)
      if (errorData.message?.errors?.[0]?.detail) {
        errorMessage = errorData.message.errors[0].detail;
      } else if (errorData.message?.errors?.[0]?.title) {
        errorMessage = errorData.message.errors[0].title;
      }
      // 2. Check for Amadeus-style errors in 'error' field (as an object)
      else if (errorData.error?.errors?.[0]?.detail) {
        errorMessage = errorData.error.errors[0].detail;
      } else if (errorData.error?.errors?.[0]?.title) {
        errorMessage = errorData.error.errors[0].title;
      }
      // 3. Check for top-level errors array
      else if (errorData.errors?.[0]?.detail) {
        errorMessage = errorData.errors[0].detail;
      }
      // 4. Check for 'error.message' as string
      else if (errorData.error?.message && typeof errorData.error.message === 'string') {
        errorMessage = errorData.error.message;
      }
      // 5. Check for 'error' as string
      else if (typeof errorData.error === 'string') {
        errorMessage = errorData.error;
      }
      // 6. Check for 'message' as string (only if it's not a generic failure message, or as last resort)
      else if (typeof errorData.message === 'string') {
        errorMessage = errorData.message;
      }
      // 7. Fallback to status
      else if (errorData.status === 'fail' && !errorData.message) {
         errorMessage = "Operation failed";
      }
    } else {
      errorMessage = error.message || "Something went wrong";
    }

    // Return an object that has a 'message' property so components using error?.message work
    return Promise.reject(
      typeof errorData === 'object' && errorData !== null
        ? { ...errorData, message: errorMessage }
        : { message: errorMessage }
    );
  }
)